import React, { useEffect, useRef } from 'react';
import { BoldIcon, ItalicIcon, TypeIcon } from 'lucide-react';
interface RichTextEditorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}
export function RichTextEditor({
  label,
  value,
  onChange,
  placeholder = '',
  rows = 3
}: RichTextEditorProps) {
  const editorRef = useRef<HTMLDivElement>(null);
  // Initialize content
  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);
  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };
  const applyFormat = (command: string, value?: string) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    handleInput();
  };
  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    document.execCommand('insertText', false, text);
  };
  return <div data-id="element-994">
      <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-995">
        {label}
      </label>

      {/* Formatting Toolbar */}
      <div className="flex items-center gap-1 mb-2 p-2 bg-stone-50 border border-stone-200 rounded-lg" data-id="element-996">
        <button type="button" onClick={() => applyFormat('bold')} className="p-2 hover:bg-stone-200 rounded transition-colors" title="Fed (Ctrl+B)" data-id="element-997">
          <BoldIcon className="w-4 h-4 text-stone-700" data-id="element-998" />
        </button>

        <button type="button" onClick={() => applyFormat('italic')} className="p-2 hover:bg-stone-200 rounded transition-colors" title="Kursiv (Ctrl+I)" data-id="element-999">
          <ItalicIcon className="w-4 h-4 text-stone-700" data-id="element-1000" />
        </button>

        <div className="w-px h-6 bg-stone-300 mx-1" data-id="element-1001" />

        <button type="button" onClick={() => applyFormat('fontSize', '3')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-xs font-medium text-stone-700" title="Lille tekst" data-id="element-1002">
          S
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '4')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-sm font-medium text-stone-700" title="Normal tekst" data-id="element-1003">
          M
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '5')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-base font-medium text-stone-700" title="Stor tekst" data-id="element-1004">
          L
        </button>

        <button type="button" onClick={() => applyFormat('fontSize', '6')} className="px-2 py-1 hover:bg-stone-200 rounded transition-colors text-lg font-medium text-stone-700" title="Meget stor tekst" data-id="element-1005">
          XL
        </button>
      </div>

      {/* Editable Content */}
      <div ref={editorRef} contentEditable onInput={handleInput} onPaste={handlePaste} className="w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all overflow-auto" style={{
      minHeight: `${rows * 1.5}rem`,
      maxHeight: '300px'
    }} data-placeholder={placeholder} data-id="element-1006" />

      <style data-id="element-1007">{`
        [contenteditable]:empty:before {
          content: attr(data-placeholder);
          color: #9ca3af;
          pointer-events: none;
        }
        [contenteditable] {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      `}</style>
    </div>;
}